/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import {
  changeFieldMessage,
  selectFieldMessage,
  sendRequest,
  selectRequestState
} from 'mt-react-common/modules/tasks/common/reducers/execCommentForm';

import TasksExecsMaterialsButtonPopUpForm from '../TasksExecsMaterialsButtonPopUpForm';
import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';
import TasksExecsMaterialsNotSendBlock from '../TasksExecsMaterialsNotSendBlock';

// eslint-disable-next-line react/prefer-stateless-function
class TasksExecMessageForm extends Component {
  componentDidUpdate(prevProp) {
    if (
      prevProp.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.closeAllTabs();
    }
  }
  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    return (
      <div className="tab-pane active">
        <div className="panel-footer pos-rel">
          {this.props.requestState.hasInProgress ? <OpacityPreLoader /> : null}
          <form>
            <div
              className={`form-group ${
                hasError(this.props.fieldMessage.errors) ? 'has-error' : ''
              }`}
            >
              <textarea
                className="form-control"
                name="comment"
                placeholder={t('Введите ваш комментарий...')}
                required=""
                rows="5"
                value={this.props.fieldMessage.value}
                onChange={e => {
                  this.props.changeFieldMessage(e.target.value);
                }}
              />
              {errorDesc(this.props.fieldMessage.errors)}
            </div>
            <TasksExecsMaterialsNotSendBlock
              formReduceName={this.props.formReduceName}
              execId={this.props.exec.id}
            />

            <div className="btn-toolbar">
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => this.props.sendRequest()}
              >
                {t('Отправить')}
              </button>
              <TasksExecsMaterialsButtonPopUpForm {...this.props} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

TasksExecMessageForm.propTypes = {
  // IN
  closeAllTabs: PropTypes.func.isRequired,
  formReduceName: PropTypes.string.isRequired,
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  fieldMessage: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  changeFieldMessage: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.formReduceName),
  fieldMessage: selectFieldMessage(state, props.formReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldMessage: value =>
    dispatch(changeFieldMessage(props.formReduceName, value)),
  sendRequest: () => dispatch(sendRequest(props.formReduceName, props.exec.id))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecMessageForm)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecMessageForm/TasksExecMessageForm.js